/**
 * Returns the Amplitude consent-proxy ingestion URL (`/no-consent`) used by
 * analytics events. Returns null when no proxy is configured (local dev).
 */
const getNoConsentServerUrl = (): string | null => {
  const baseUrl = import.meta.env.VITE_AMPLITUDE_PROXY_BASE_URL
  if (!baseUrl) return null

  const url = new URL(baseUrl)
  url.pathname = 'no-consent'
  return url.toString()
}

export default { getNoConsentServerUrl }
